import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import struggleImage from '../assets/OurChallenges/10.jpeg';
import rationsImage from '../assets/OurChallenges/11.jpeg';
import sanitaryImage from '../assets/OurChallenges/17.jpeg';
import medicineImage from '../assets/OurChallenges/29.jpeg';
import sponsorImage from '../assets/OurChallenges/18.jpeg';

const OurChallenges = () => {
    return (
        <div className="p-3 p-md-5 p-lg-10 bg-light">
            <div className="container">
                {/* Section 1: Our Struggle */}
                <div className="row mb-5 align-items-center animate__animated animate__fadeIn" style={{ marginTop: '20px' }}>
                    <div className="col-md-6 order-md-1 order-2 text-start mt-3 mt-md-0">
                        <h2 className="mb-3 mb-md-4 fw-bold text-dark" style={{ fontSize: '2rem', fontFamily: 'Georgia' }}>
                            Our Struggle
                        </h2>
                        <p className="text-muted mb-3 mb-md-4" style={{ lineHeight: '1.6', fontSize: '1rem' }}>
                            As you can imagine, the need is immense. We rely solely on donations to support and care for our 273+ inmates of all ages with different disabilities across 10 homes. Every day, we work tirelessly to secure enough funds and provisions to sustain life-saving efforts. Our expenses include bills, rentals, medicine, transportation, and more.
                        </p>
                        <Link to="/contact-us" style={{ textDecoration: 'none' }}>
                            <button
                                className="btn btn-success text-uppercase"
                                style={{
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontWeight: '500',
                                    transition: 'background-color 0.3s ease, transform 0.3s ease',
                                    fontSize: '0.9rem'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#218838';
                                    e.target.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#28a745';
                                    e.target.style.transform = 'scale(1)';
                                }}
                            >
                                Donate Now
                            </button>
                        </Link>
                    </div>
                    <div className="col-md-6 order-md-2 order-1">
                        <img
                            src={struggleImage}
                            alt="Our Struggle"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: '400px',
                                width: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>
                </div>

                {/* Section 2: Rations Needed */}
                <div className="row mb-5 align-items-center animate__animated animate__fadeIn">
                    <div className="col-md-6 order-md-2 order-2 text-start mt-3 mt-md-0">
                        <h2 className="mb-3 mb-md-4 fw-bold text-dark" style={{ fontSize: '2rem', fontFamily: 'Georgia' }}>
                            Rations Needed for a Month
                        </h2>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item bg-transparent py-2">Rice – 1750kg</li>
                            <li className="list-group-item bg-transparent py-2">Dhal – 165kg</li>
                            <li className="list-group-item bg-transparent py-2">Sugar – 460kg</li>
                            <li className="list-group-item bg-transparent py-2">Onions – 175kg</li>
                            <li className="list-group-item bg-transparent py-2">Oil – 60 liters</li>
                            <li className="list-group-item bg-transparent py-2">Chilli – 30.5kg</li>
                            <li className="list-group-item bg-transparent py-2">Chilli flakes – 36.5kg</li>
                            <li className="list-group-item bg-transparent py-2">Curry powder – 25kg</li>
                            <li className="list-group-item bg-transparent py-2">Salt – 110 packets</li>
                            <li className="list-group-item bg-transparent py-2">Turmeric powder – 9kg</li>
                            <li className="list-group-item bg-transparent py-2">Milk powder – 310 (400g)</li>
                            <li className="list-group-item bg-transparent py-2">Salmon tins – 120</li>
                            <li className="list-group-item bg-transparent py-2">Coconut – 2170</li>
                        </ul>
                    </div>
                    <div className="col-md-6 order-md-1 order-1">
                        <img
                            src={rationsImage}
                            alt="Rations Needed"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: '400px',
                                width: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>
                </div>

                {/* Section 3: Sanitary Items */}
                <div className="row mb-5 align-items-center animate__animated animate__fadeIn">
                    <div className="col-md-6 order-md-1 order-2 text-start mt-3 mt-md-0">
                        <h2 className="mb-3 mb-md-4 fw-bold text-dark" style={{ fontSize: '2rem', fontFamily: 'Georgia' }}>
                            Sanitary Items
                        </h2>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item bg-transparent py-2">Soap</li>
                            <li className="list-group-item bg-transparent py-2">Toothpaste/Toothbrush</li>
                            <li className="list-group-item bg-transparent py-2">Washing liquid</li>
                            <li className="list-group-item bg-transparent py-2">Washing powder</li>
                            <li className="list-group-item bg-transparent py-2">Pampers – children/adults</li>
                            <li className="list-group-item bg-transparent py-2">Harpic/Bleaching</li>
                        </ul>
                    </div>
                    <div className="col-md-6 order-md-2 order-1">
                        <img
                            src={sanitaryImage}
                            alt="Sanitary Items"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: '400px',
                                width: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>
                </div>

                {/* Section 4: Medicine and Hospital Expenses */}
                <div className="row mb-5 align-items-center animate__animated animate__fadeIn">
                    <div className="col-md-6 order-md-2 order-2 text-start mt-3 mt-md-0">
                        <h2 className="mb-3 mb-md-4 fw-bold text-dark" style={{ fontSize: '2rem', fontFamily: 'Georgia' }}>
                            Medicine and Hospital Expenses
                        </h2>
                        <p className="text-muted mb-3" style={{ lineHeight: '1.6', fontSize: '1rem' }}>
                            Out of 260 inmates, 80% are under medical treatment. Approximately 40% of these inmates visit hospitals monthly for clinics and medication, and 10% require hospitalization for various illnesses. Each hospitalization necessitates hiring a caretaker for a minimum of 3 days.
                        </p>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item bg-transparent py-2">Cost for a caretaker per day: Rs. 2050</li>
                            <li className="list-group-item bg-transparent py-2">Average monthly hospital expenses:</li>
                            <li className="list-group-item bg-transparent py-2 ps-4">Medicine: Rs. 18,000</li>
                            <li className="list-group-item bg-transparent py-2 ps-4">Transport: Rs. 4,500</li>
                            <li className="list-group-item bg-transparent py-2 ps-4">Caretaker: Rs. 16,500</li>
                            <li className="list-group-item bg-transparent py-2 ps-4">Total: Rs. 39,000</li>
                        </ul>
                    </div>
                    <div className="col-md-6 order-md-1 order-1">
                        <img
                            src={medicineImage}
                            alt="Medicine and Hospital Expenses"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: '400px',
                                width: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>
                </div>

                {/* Section 5: Sponsor Us */}
                <div className="row mb-5 align-items-center animate__animated animate__fadeIn">
                    <div className="col-md-6 order-md-1 order-2 text-start mt-3 mt-md-0">
                        <h2 className="mb-3 mb-md-4 fw-bold text-dark" style={{ fontSize: '2rem', fontFamily: 'Georgia' }}>
                            Sponsor Us
                        </h2>
                        <p className="text-muted mb-3 mb-md-4" style={{ lineHeight: '1.6', fontSize: '1rem' }}>
                            Your support can make a significant difference. Help us cover essential expenses and provide critical equipment to improve the lives of our inmates.
                        </p>
                        <ul className="list-group list-group-flush mb-3 mb-md-4">
                            <li className="list-group-item bg-transparent py-2">Electricity/Water/Telephone bills</li>
                            <li className="list-group-item bg-transparent py-2">Medical equipment</li>
                            <li className="list-group-item bg-transparent py-2">Other equipment</li>
                        </ul>
                        <div className="d-flex flex-wrap gap-2 gap-md-3">
                            <Link to="/contact-us" style={{ textDecoration: 'none' }}>
                                <button
                                    className="btn btn-success text-uppercase"
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 20px',
                                        fontWeight: '500',
                                        transition: 'background-color 0.3s ease, transform 0.3s ease',
                                        fontSize: '0.9rem'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#218838';
                                        e.target.style.transform = 'scale(1.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#28a745';
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                >
                                    Sponsor Now
                                </button>
                            </Link>

                        </div>
                    </div>
                    <div className="col-md-6 order-md-2 order-1">
                        <img
                            src={sponsorImage}
                            alt="Sponsor Us"
                            className="img-fluid rounded shadow-lg"
                            style={{
                                maxHeight: '350px',
                                width: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block'
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.02)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurChallenges;